
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M56.5 53.42L30 33.22 3.5 53.42h53zM24.33 19A5.67 5.67 0 1130 24.65v8.57"}})])
          )
        }
      }
    